import { Fragment } from 'react';

import { Text } from '@bonusly/design-system';

export interface BizyRecognitionInlineProps {
	recipients?: string[];
	amount?: number;
	message?: string;
	hashtags?: string[];
}

/**
 * Renders a recognition preview inline: `@recipient +amount message #hashtag`.
 * Shared by BizyApprovalCard, BizyContentCard, and BizyDraftCard so the three
 * cards stay visually identical and normalize inputs the same way.
 */
export function BizyRecognitionInline({ recipients, amount, message, hashtags }: BizyRecognitionInlineProps) {
	return (
		<>
			{recipients?.map((r, i) => (
				<Fragment key={r}>
					{i > 0 && ' '}
					<Text as="span" fontSize="inherit" fontWeight="medium" color="text.interactive">
						@{r}
					</Text>
				</Fragment>
			))}
			{(amount ?? 0) > 0 && (
				<>
					{' '}
					<Text as="span" fontSize="inherit" fontWeight="semibold" color="success.text" bg="success.bg" px={1} py={0.5} borderRadius="md">
						+{amount}
					</Text>
				</>
			)}
			{message && <> {message}</>}
			{hashtags?.map((tag) => (
				<Fragment key={tag}>
					{' '}
					<Text as="span" fontSize="inherit" fontWeight="medium" color="info.text">
						{tag.startsWith('#') ? tag : `#${tag}`}
					</Text>
				</Fragment>
			))}
		</>
	);
}
